import { render, staticRenderFns } from "./FilterHotelBlock.vue?vue&type=template&id=dd458292&"
import script from "./FilterHotelBlock.vue?vue&type=script&lang=js&"
export * from "./FilterHotelBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports